import React, { useEffect, useMemo, useState } from 'react';
import { Avatar, Button, Text } from 'react-native-paper';
import { Modal, Platform, ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import getGlobalStyles from '../globalStyles';
import { useThemeSettings } from '../ThemeProvider';
import { ButtonVariant, CustomButton } from './CustomButton';
import WebView from 'react-native-webview';
import { useSources } from '../services/tanStackService';
import { useModalStore } from '../store/modalStore';
import { FULL_WIDTH } from '../shared/constants/dimension';

export const SourcesModal: React.FC<{ updateTitle?: (title: string) => void }> = ({ updateTitle }) => {
  const { t } = useTranslation();
  const { theme } = useThemeSettings();
  const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);
  const [url, setUrl] = useState<string | null>(null);
  const modalProps = useModalStore((state) => state.modalAdditionalProps);
  const { data: sources, isFetching: isFetching } = useSources(modalProps?.articleId!);

  useEffect(() => {
    updateTitle && updateTitle(t("screens.sources.title", { count: sources?.length }))
  }, [sources])
  return (
    <View style={{ paddingHorizontal: 12, width: FULL_WIDTH }}>
      <ScrollView style={{ maxHeight: 400 }} showsVerticalScrollIndicator={false}>
        {sources?.map((source: any, index: number) => {
          return <View key={index} style={{ paddingBottom: 10 }}>
            <Text style={gStyles.header2}>{source?.title}</Text>
            <CustomButton mode="text"
              variant={ButtonVariant.TRANSPARENT}
              icon={() => (
                <Avatar.Image size={32} source={{ uri: source.logo }} />
              )}
              contentStyle={{ height: 40, justifyContent: 'flex-start' }}
              iconSize={32}
              onPress={() => Platform.OS === 'web' ? window.open(source.url, '_blank').focus() : setUrl(source.url)}>
              <Text style={[{ textAlign: 'left', color:theme.colors.textPrimary }]}>{source?.name}</Text>
            </CustomButton>
          </View>
        })
        }</ScrollView>
      <Modal visible={url !== null} animationType="slide">
        <View style={{ flex: 1 }}>
        <TouchableOpacity onPress={() => setUrl(null)} style={{alignSelf : "flex-end", paddingRight : 20, paddingBottom : 10}}>
                    <View style={[ styles.closeCircle, { borderColor: theme?.colors?.black }]}>
                      <Text style={[styles.closeText, { color: theme?.colors?.black }]}>✕</Text>
                    </View>
          </TouchableOpacity>
          <WebView source={{ uri: url || '' }} style={{ flex: 1 }} />
        </View>
      </Modal>
    </View>
  );
}
const styles = StyleSheet.create({
closeText: {
    fontSize: 18,
    fontWeight: "900",
  },
  closeCircle: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 2,
    justifyContent: "center",
    alignItems: "center",
  },
});